import React, { useEffect, useState } from "react";
import { Button, Card, Col, Stack } from "react-bootstrap";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { deleteRoom, patchRoom } from "../../../services/httpClient";
import { unsavedChanges } from "../../../App";
import Input from "../../ui/Input";
import IconButton from "../../ui/IconButton";

interface CardState {
  room: any;
  getItems: any;
  setSelectedRoom: any;
  setOrgToSave: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const RoomManagementCard = ({
  room,
  getItems,
  setSelectedRoom,
  setOrgToSave,
  setErrMessage,
  setShowToast,
  setToastText,
  setToastBody,
}: CardState) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [itemName, setItemName] = useState<string>("");

  useEffect(() => {
    if (room) {
      setItemName(room?.name);
    }
  }, [room]);

  const onClickEdit = (e: any) => {
    e.stopPropagation();
    setIsEditing(true);
  };
  const onClickManageBeds = (e: any) => {
    e.stopPropagation();
    setSelectedRoom(room);
    setIsEditing(true);
  };

  const onClickEditFinal = () => {
    if (!itemName) {
      setErrMessage("Cannot set null room name");
      window.scrollTo({
        top: 0,
        behavior: "auto",
      });
      return;
    }
    const updatedRoom = {
      name: itemName,
    };

    setErrMessage("");

    patchRoom(updatedRoom, room?.id)
      .then((res: any) => {
        unsavedChanges.value = false;
        setOrgToSave(false);
        setShowToast(true);
        setToastText("Room Updated");
        setToastBody(itemName);
        setIsEditing(false);
        getItems();
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
      });
  };

  const onClickCancelEdit = () => {
    unsavedChanges.value = false;
    setOrgToSave(false);
    setIsEditing(false);
    setErrMessage(undefined);
  };

  const onUpdateName = (e: any) => {
    setItemName(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
    setErrMessage(undefined);
  };

  const onClickDelete = (e: any) => {
    e.stopPropagation();
    setIsDeleting(true);
  };

  const onClickDeleteFinal = () => {
    setErrMessage("");
    deleteRoom(room?.id)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Room Deleted");
        setToastBody(room?.name);
        setIsDeleting(false);

        getItems();
      })
      .catch((err: any) => {
        setIsDeleting(false);
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelDelete = () => {
    setErrMessage("");
    setIsDeleting(false);
    setErrMessage(undefined);
  };

  const renderEdit = () => {
    return (
      <Card key={room.name} className="bg-light mb-1">
        <Card.Body>
          <Stack direction="horizontal" gap={3}>
            <Col>
              <Input label="Name" type="text" value={itemName} onUpdate={(e: any) => onUpdateName(e)} />
            </Col>
            <Button className="app-secondary-color button" onClick={onClickEditFinal}>
              Save
            </Button>
            <div className="vr" />
            <Button className="app-primary-color button" onClick={onClickCancelEdit}>
              Cancel
            </Button>
          </Stack>
        </Card.Body>
      </Card>
    );
  };

  const renderDelete = () => {
    return (
      <Card key={room.name} className="bg-light mb-1">
        <Card.Body>
          <Stack direction="horizontal" gap={3}>
            <Stack style={{ justifyContent: "center" }} gap={2}>
              <Card.Subtitle>Are you sure you want to delete {room?.name}, beds, and occupants?</Card.Subtitle>
            </Stack>
            <Button className="app-danger-color button" onClick={onClickDeleteFinal}>
              Confirm Delete
            </Button>
            <div className="vr" />
            <Button className="app-primary-color button" onClick={onClickCancelDelete}>
              Cancel
            </Button>
          </Stack>
        </Card.Body>
      </Card>
    );
  };

  return (
    <>
      {isEditing ? (
        <>{renderEdit()}</>
      ) : isDeleting ? (
        <>{renderDelete()}</>
      ) : (
        <Card className="bg-light mb-0">
          <Card.Body className="p-2">
            <Stack direction="horizontal" gap={3}>
              <Stack gap={2} className="align-self-center">
                <Card.Subtitle className="text-muted">
                  <small>{room?.name}</small>
                  <small className="text-muted"> - {room?.bed_count}</small>
                </Card.Subtitle>
              </Stack>
              <Button className="app-primary-color-inverse button" onClick={(e) => onClickManageBeds(e)}>
                Manage Beds
              </Button>
              <div className="vr" />
              <IconButton onClickButton={onClickEdit} tooltipText={"Edit"} icon={faEdit} />
              <div className="vr" />
              <IconButton onClickButton={onClickDelete} tooltipText={"Delete"} icon={faTrash} />
            </Stack>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default RoomManagementCard;
